<template>
  <el-container>
    <el-main>
      <el-row  justify="space-start" :gutter="20">
        <el-col  :xs-and-down="{span: 8}" :lg="{span: 8}" :md="{span: 8}">
          <el-card class="box-card" v-if="classroom.length > 0">
            <h4 class="card-title">Invoice for {{classroom[0].code}}</h4>
            <p><strong>Location:</strong> {{classroom[0].venue.name}}</p>
            <p><strong>Date:</strong> {{classroom[0].startDate | moment('DD MMM YYYY')}} - {{classroom[0].endDate | moment('DD MMM YYYY')}}</p>
            <div class="card-header">

              <div class="card-content">

                <el-row style="margin-top:30px; margin-bottom: 10px">

                  <el-form :model="invoice" :rules="rules" ref="invoice" label-width="100px" class>
                    <el-form-item label="Invoice Total" prop="invoiceTotal">
                      <el-input placeholder="Total" v-model="classroom[0].invoiceAmount">{{classroom[0].invoiceAmount}}</el-input>
                    </el-form-item>
                    <el-button
                      v-if="!classroom[0].invoiceAmount && !classroom[0].invoicePaid"
                      style="width:100%"
                      type="primary"
                      @click="createInvoice(classroom[0].invoiceAmount)"
                    >Save</el-button>
                    <el-button
                      v-if="classroom[0].invoiceAmount && !classroom[0].invoicePaid"
                      style="width:100%"
                      type="primary"
                      @click="createInvoice(classroom[0].invoiceAmount)"
                    >Update</el-button>
                    <el-button
                      v-if="classroom[0].invoicePaid"
                      style="width:100%"
                      type="primary"
                      disabled
                      @click="createInvoice(classroom[0].invoiceAmount)"
                    >Update</el-button>
                    <br><br>
                    <small v-if="classroom[0].invoicePaid">This invoice has been paid and can no longer be updated</small>

                  </el-form>
                
                </el-row>

              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs-and-down="{span: 8}" :lg="{span: 8}" :md="{span: 16}">
          <el-card class="box-card">
            <h4 class="card-title">Invoice details</h4>
            <div class="card-header">

              <div class="card-content">


                <data-tables-server 
                  class="table-shopping" 
                  style="width: 100%" 
                  :data="classroom" 
                  :tool-bar="false" 
                  :current-page="1" 
                  :total="total"
                  :loading="loadingInvoices"
                  :page-size="10"
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                  <el-table-column label="ID" min-width="10">
                    <template slot-scope="props">{{props.row.id}}</template>
                  </el-table-column>

                  <el-table-column label="Total" min-width="10">
                    <template slot-scope="props" v-if="tutors.length > 0">{{props.row.invoiceAmount | currentyCodeToSymbol(tutors[0].currency)}}</template>
                  </el-table-column>

                  <el-table-column label="Paid" min-width="8">
                    <template slot-scope="props">
                      <small class="label label-success" v-if="props.row.invoicePaid === 1">Yes</small>
                      <small class="label label-danger" v-if="props.row.invoicePaid === 0">No</small>
                    </template>
                  </el-table-column>

                  <el-table-column label="Date" min-width="10">
                    <template slot-scope="props" v-if="props.row.invoicePaidDate != ''">{{props.row.invoicePaidDate | moment('DD MMM YYYY')}}</template>
                    <template slot-scope="props" v-if="props.row.invoicePaidDate == undefined">N/A</template>
                  </el-table-column>

                </data-tables-server>
              </div>
            </div>
            <div class="card-content"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
//import InvoiceFilter from "../UIComponents/InvoiceFilter.vue";
//import VenueFilter from "../UIComponents/VenueFilter.vue";
import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      total: 0,
      countries: [],
      invoices: [],
      classroom: [],
      newInvoice: {},
      aggregate: {},
      total: 0,
      invoice: {},
      filters: [ 
        {
          value: "ALL",
          prop: "venue"
        },
        {
          value: "20",
          prop: "numAttendees",
        },
        {
          value: [
            moment().subtract(1, "years").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ],
          prop: "startDate"
        },
        {
          value: "_lte",
          prop: "numAttendees",
        },
      ],
      loadingInvoices: false,
      selectedCountry: "",
      selectedVenue: {},
      selectedTutor: {},
      tutor: {},
      tutors: [],
      venues: [],
      classVenues: [],
      venue: {},
      loading: false,
     
      rules: {
        meta: {'invoice-code':[
          { required: true, message: "Please add code", trigger: "blur" }
        ]}
      }
    };
  },
  methods: {

    getClassroom(id) {

      this.loadingClassroom = true;

      this.$apollo
      .query({
        query: gql`
        {
          ClassRoom(where: {id: {_eq: ${id}}}) {
            id
            code
            isPublic
            length
            maxAttendees
            numAttendees
            venueId
            tutorId
            startDate
            endDate
            invoiceAmount
            invoiceBonus
            invoiceDate
            invoicePaid
            invoicePaidDate
            numberOfTens
            recommendedPercentage
            serviceRatingPercentage
            tutorRatingPercentage
            tutorId
            feedbackCount
            tutor {
              id
              firstname
              lastname
              email
            }
            venue {
              id
              town
              region
              country
              name
              line1
            }
            attendees {
              customer {
                id
                firstname
                lastname
              }
            }
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        console.log(response.data.ClassRoom)
        this.classroom = response.data.ClassRoom;
        this.loadingClassroom = false;
      });
    },

    createInvoice(invoiceAmount){

      var id = this.$route.params.id;
      var invoiceDate = moment().format("YYYY-MM-DD")

       // console.dir(this.currentPrice.prices[2])
        const q = gql`
          mutation update_ClassRoom($id: Int, $invoiceAmount: float8, $invoiceDate: timestamp) {
            update_ClassRoom(where: { id: { _eq: $id } }, _set: {invoiceAmount : $invoiceAmount, invoiceDate: $invoiceDate}) {
              affected_rows
              returning {
                id
                code
                isPublic
                length
                maxAttendees
                numAttendees
                venueId
                tutorId
                startDate
                endDate
                invoiceAmount
                invoiceBonus
                invoiceDate
                invoicePaid
                invoicePaidDate
                numberOfTens
                recommendedPercentage
                serviceRatingPercentage
                tutorRatingPercentage
                tutorId
                feedbackCount
                tutor {
                  id
                  firstname
                  lastname
                  email
                }
                venue {
                  id
                  town
                  region
                  country
                  name
                  line1
                }
                attendees {
                  customer {
                    id
                    firstname
                    lastname
                  }
                }
              }
            }
          }
      `;

      this.$apollo
      
      .mutate({
        mutation: q,
        variables: {
          id: id,
          invoiceAmount: invoiceAmount,
          invoiceDate: invoiceDate
        }
      })

      .then(result => {
        this.$notify({
          title:"Success",
          message: "Invoice amount updated",
          type: "success"
        });
        this.classroom = result.data.update_ClassRoom.returning
        //this.getRegister(this.$route.params.id);
        // return result
      })
      .catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
    },

    getTutors() {

      var id = this.id
      this.loadingTutors = true;

      this.$apollo
      .query({
        query: gql`
        {
          Tutor(
            limit: 1,
            where: {id: {_eq: ${id}}}
          ) {
            id
            firstname
            lastname
            currency
            email
            rating
            isActive
            canLogin
            rating
            address {
              id
              line1
              line2
              country
              town
              phone
            }
          
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.tutors = response.data.Tutor;
        this.loadingTutors = false;
      });
    },
generateInvoice(){

        var tutorId = this.$route.params.id
        var uniqid = this.uniqueID()
        var dateCreated = moment().format("YYYY-MM-DD");
        var dateUpdated = moment().format("YYYY-MM-DD");
        var invoiceDate = moment().format("YYYY-MM-DD");
        
        //Set default values
        var invoiceTotal = 0;
        var classRoomTotal = 0;
        var bonusTotal = 0;

        //Calculate bonus
        bonusTotal = calculateBonus()

        //Calculate Classroom Totals
        classRoomTotal = calculateClassrooms();

        //Set invoice total
        invoiceTotal = classRoomTotal + bonusTotal;

        var sign = '£';
        var currency = this.tutors[0].currency;
        switch (currency) {
            case 'GBP':
                sign = "£";
                break;
            case 'EUR':
                sign = "€";
                break;
            case 'USD':
                sign = "$";
                break;
            default:
                sign = "£";
                break;
        }
        
        var sourceUrl = 'application/assets/pdfs/invoices/'+uniqid+'.pdf';
        var isPaid = 0;
        var paidDate = null;

       // console.dir(this.currentPrice.prices[2])
        const q = gql`
          mutation insert_TutorInvoice(
            $tutorId: Int, 
            $invoiceTotal: float8, 
            $dateCreated: timestamp, 
            $dateUpdated: timestamp,
            $invoiceDate: timestamp,
            $classRoomTotal: float8,
            $bonusTotal: float8,
            $sourceUrl: String,
            $isPaid: smallint,
            $paidDate: timestamp, 
          ) {
            insert_TutorInvoice(objects: {
              tutorId: $tutorId, 
              invoiceTotal: $invoiceTotal, 
              dateCreated : $dateCreated, 
              dateUpdated : $dateUpdated,
              invoiceDate : $invoiceDate,
              classRoomTotal: $classRoomTotal,
              bonusTotal: $bonusTotal,
              sourceUrl: $sourceUrl,
              isPaid: $isPaid,
              paidDate: $paidDate
            }) {
              affected_rows
              returning {
                id
              }
            }
          }
      `;

      this.$apollo
      
      .mutate({
        mutation: q,
        variables: {
          tutorId: tutorId,
          invoiceTotal: invoiceTotal,
          dateCreated: dateCreated,
          dateUpdated: dateUpdated,
          invoiceDate: invoiceDate,
          classRoomTotal: classRoomTotal,
          bonusTotal: bonusTotal,
          sourceUrl: sourceUrl,
          isPaid: isPaid,
          paidDate: paidDate
        }
      })

      .then(result => {
        this.$notify({
          title:"Invoice Saved",
          message: "Invoice saved successfully",
          type: "success"
        });
        //this.getRegister(this.$route.params.id);
        // return result
      })
      .catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
    }
    /*
    createInvoice(invoiceTotal){

        var tutorId = this.id
        var dateCreated = moment().format("YYYY-MM-DD");
        var dateUpdated = dateCreated;
        var classRoomTotal = invoiceTotal;
        var bonusTotal = 0;
        var sourceUrl = '';
        var isPaid = 0;

       // console.dir(this.currentPrice.prices[2])
        const q = gql`
          mutation insert_TutorInvoice(
            $tutorId: Int, 
            $invoiceTotal: float8, 
            $dateCreated: timestamp, 
            $dateUpdated: timestamp,
            $classRoomTotal: float8,
            $bonusTotal: float8,
            $sourceUrl: String,
            $isPaid: smallint
          ) {
            insert_TutorInvoice(objects: {
              tutorId: $tutorId, 
              invoiceTotal: $invoiceTotal, 
              dateCreated : $dateCreated, 
              dateUpdated : $dateUpdated,
              classRoomTotal: $classRoomTotal,
              bonusTotal: $bonusTotal,
              sourceUrl: $sourceUrl,
              isPaid: $isPaid
            }) {
              affected_rows
              returning {
                id
              }
            }
          }
      `;

      this.$apollo
      
      .mutate({
        mutation: q,
        variables: {
          tutorId: tutorId,
          invoiceTotal: invoiceTotal,
          dateCreated: dateCreated,
          dateUpdated: dateUpdated,
          classRoomTotal: classRoomTotal,
          bonusTotal: bonusTotal,
          sourceUrl: sourceUrl,
          isPaid: isPaid
        }
      })

      .then(result => {
        this.$notify({
          title:"Invoice Saved",
          message: "Invoice saved successfully",
          type: "success"
        });
        //this.getRegister(this.$route.params.id);
        // return result
      })
      .catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
    },
    */
  },
  mounted() {
    this.getClassroom(this.$route.params.id);
    this.getTutors();
  },
  computed: {
    id(){
      const token = localStorage.getItem('vuex')
      const parsed = JSON.parse(token)
      const id = parsed['auth']['id']
      console.log('id: ', id);
      return id
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Tutor/Invoice.vue